/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams, AuditReportsGetOlafReprocessJobStatusByReprocessKey401, AuditReportsGetOlafReprocessJobStatusByReprocessKey403, AuditReportsGetOlafReprocessJobStatusByReprocessKey404 } from "../models/AuditReportsGetOlafReprocessJobStatusByReprocessKey";

export function getAuditReportsGetOlafReprocessJobStatusByReprocessKeyUrl(reprocessKey: AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/olaf/reprocess/job-status-by-reprocess-key/${reprocessKey}` as const }
  return res
}

/**
 * @description Finds and returns the most recent reprocess job for the given reprocess key within the user's client.
 * @summary Get OLAF reprocess job status by reprocess key
 * {@link /audit-reports/v1/olaf/reprocess/job-status-by-reprocess-key/:reprocessKey}
 */
export async function auditReportsGetOlafReprocessJobStatusByReprocessKey(reprocessKey: AuditReportsGetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByReprocessKey401 | AuditReportsGetOlafReprocessJobStatusByReprocessKey403 | AuditReportsGetOlafReprocessJobStatusByReprocessKey404>, unknown>({ method : "GET", url : getAuditReportsGetOlafReprocessJobStatusByReprocessKeyUrl(reprocessKey).url.toString(), ... requestConfig })
  return res.data
}